import { translateDbError } from './db-error-message'

// Helper chung cho error message của react-query mutations. Trước đó được
// duplicate 14 lần ở các feature hooks — extract sang đây để có 1 chỗ chỉnh
// label (vd thêm Sentry capture, hoặc localize sang nhiều ngôn ngữ).

export function describeError(error: unknown): string {
  // Lỗi RPC có dạng '<mã>: chi tiết' — dịch sang câu nói rõ việc cần làm. Mã lạ
  // → translateDbError trả null, giữ nguyên chuỗi gốc (đừng nuốt manh mối).
  if (error instanceof Error) return translateDbError(error.message) ?? error.message
  // Supabase/PostgREST trả PostgrestError dạng OBJECT (không phải Error
  // instance) → trước đây rơi vào nhánh generic, che mất lý do thật (vd
  // "column ... does not exist", RLS denied...). Bóc message/details/hint ra.
  if (error && typeof error === 'object') {
    const e = error as {
      message?: unknown
      details?: unknown
      hint?: unknown
      error?: unknown
    }
    const msg =
      (typeof e.message === 'string' && e.message) ||
      (typeof e.details === 'string' && e.details) ||
      (typeof e.hint === 'string' && e.hint) ||
      (typeof e.error === 'string' && e.error)
    if (msg) return translateDbError(msg) ?? msg
  }
  return 'Có lỗi xảy ra. Vui lòng thử lại.'
}
